import styled from 'styled-components';

import Color from '../../styles/color';

export const Container = styled.div`
  background: #e5e5e5;
  border-radius: 4px;
  padding: 24px 16px 16px 16px;
  margin: 24px 0;

  h5 {
    font-size: 16px;
    line-height: 20px;
    color: ${Color.neutral};
    margin-bottom: 10px;
    text-align: center;
  }
`;

export const ButtonContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%100em;
  height: 48px;
  border-radius: 8px;
  border: none;
  background-color: ${Color.success};
  color: ${Color.white};
  font-size: 16px;
  text-decoration: none;
  transition: all 300ms ease;
  margin-top: 10px;

  &:hover {
    opacity: 0.8;
  }
`;
